import { serverApi } from "./serverApi";
import { TestPlan } from "../types/testPlanTypes";

export const testPlanService = serverApi.injectEndpoints({
  endpoints: (build) => ({
    getAllTestPlan: build.query<Array<TestPlan>, string>({
      query: () => ({
        url: "/test-plans/all-test-plans"
      })
    }),
    createTestPlan: build.mutation<number, TestPlan>({
      query: (request) => ({
        url: "/test-plans/test-plan",
        method: "POST",
        body: request
      })
    }),
    updateTestPlan: build.mutation<string, TestPlan>({
      query: (request) => ({
        url: "/test-plans/test-plan",
        method: "PUT",
        body: request
      })
    }),
    deleteTestPlan: build.mutation<string, number>({
      query: (testPlanId) => ({
        url: "/test-plans/test-plan",
        method: "DELETE",
        params: { id: testPlanId }
      })
    }),
    updateTestPlanScenarios: build.mutation<string, TestPlan>({
      query: (scenario) => ({
        url: "/test-plans/test-plan/scenarios",
        method: "POST",
        body: {
          testPlanId: scenario.id,
          assignedScenarios: scenario.assignedScenarios
        }
      })
    }),
  })
});

export const {
  useGetAllTestPlanQuery,
  useCreateTestPlanMutation,
  useUpdateTestPlanMutation,
  useDeleteTestPlanMutation,
  useUpdateTestPlanScenariosMutation
} = testPlanService;